module.exports = __webpack_public_path__ + "img/slide2_img1.c51368f1.png";